import { create } from "zustand";

const useHeaderStore = create(set => ({
  title: null,
  subtitle: null,
  onBack: null,
  jobPlan: null,
  isHeaderAction: false,
  onJobBoost: null,
  onJobUpgrade: null,
  isJobClosed: false,
  setHeader: ({
    title,
    subtitle,
    onBack,
    jobPlan,
    isHeaderAction,
    onJobBoost,
    onJobUpgrade,
    isJobClosed
  }) =>
    set({
      title,
      subtitle,
      onBack,
      jobPlan,
      isHeaderAction,
      onJobBoost,
      onJobUpgrade,
      isJobClosed
    }),
  resetHeader: () =>
    set({
      title: null,
      subtitle: null,
      onBack: null,
      jobPlan: null,
      isHeaderAction: false,
      onJobBoost: null,
      onJobUpgrade: null,
      isJobClosed: false
    })
}));

export default useHeaderStore;
